import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { tagList, filterInvestor } from "../Config/config";
import { UserContext } from "../Contexts/UserContext";

export const useFilterOptions = ({ loadTags = true } = {}) => {
  const { getToken } = useContext(UserContext);

  const [tagOptions, setTagOptions] = useState([]);
  const [loadingTags, setLoadingTags] = useState(false);
  const [tagsError, setTagsError] = useState(null);

  const [investorOptions, setInvestorOptions] = useState([]);
  const [loadingInvestors, setLoadingInvestors] = useState(false);
  const [investorsError, setInvestorsError] = useState(null);

  const fetchTags = async (type) => {
    setLoadingTags(true);
    setTagsError(null);
    try {
      const response = await axios.post(
        tagList,
        {
          tag: "ALL",
          type,
        },
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );

      if (response.status === 200) {
        setTagOptions(response.data || []);
      } else {
        setTagOptions([]);
      }
    } catch (error) {
      setTagsError(error?.message || "Failed to fetch tags");
      setTagOptions([]);
    } finally {
      setLoadingTags(false);
    }
  };

  const fetchInvestors = async (searchText = "") => {
    setLoadingInvestors(true);
    setInvestorsError(null);
    try {
      const response = await axios.post(
        filterInvestor,
        {
          search_key: searchText,
          category: "investments",
        },
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );

      if (response.status === 200) {
        console.log(response.data, "investor response");
        setInvestorOptions(response.data.results || []);
      } else {
        setInvestorOptions([]);
      }
    } catch (error) {
      setInvestorsError(error?.message || "Failed to fetch investors");
      setInvestorOptions([]);
    } finally {
      setLoadingInvestors(false);
    }
  };

  useEffect(() => {
    if (loadTags) {
      fetchTags();
    }
  }, [loadTags]);

  return {
    tagOptions,
    loadingTags,
    tagsError,
    refreshTags: fetchTags,
    investorOptions,
    loadingInvestors,
    investorsError,
    refreshInvestors: fetchInvestors,
  };
};
